// 330: Můj Přehled — co si kdo chce na Přehledu sledovat. Drží se u účtu (user.home_prefs z /auth/me,
// ukládá PUT /auth/home) jako seznam VYPNUTÉHO, takže nový zdroj je pro všechny zapnutý sám od sebe.
// Co člověk smí vidět, se tu nenastavuje: zámek se odvozuje z jeho menu (sideFor) a hlídá ho server.

export const HOME_SOURCES = [
  ["ukoly", "Úkoly", "Na dnes, po termínu i hotové"],
  ["dochazka", "Docházka", "Kdo je v práci, odchody, ke schválení"],
  ["doklady", "Doklady", "Nahrané faktury a účtenky, po splatnosti"],
  ["objednavky", "Objednávky", "Dodávky dnes, nedorazilo, k vyzvednutí"],
  ["denik", "Deník", "Zápisy a nezapsané dny"],
];
export const HOME_CARDS = [["zitra", "Plán na zítřek"], ["terminy", "Termíny do 14 dní"]];

export const cleanHome = (v) => ({
  off: Array.isArray(v?.off) ? v.off.filter((k) => HOME_SOURCES.some(([s]) => s === k)) : [],
  cards_off: Array.isArray(v?.cards_off) ? v.cards_off.filter((k) => HOME_CARDS.some(([c]) => c === k)) : [],
});

// klíče modulů z menu člověka (sideFor) → které zdroje osy smí zapnout
export const allowedSources = (menuKeys) => HOME_SOURCES.map(([k]) => k).filter((k) => menuKeys.includes(k));

export const toggled = (list, key) => (list.includes(key) ? list.filter((x) => x !== key) : [...list, key]);
